module.exports = __webpack_public_path__ + "assets/a5a264f0d52d0038d9cb0aa2b1dd4d31.png";